/**
 * バナーの既読（閉じた）状態をlocalStorageに記憶する。
 * `censorshipNotices.ts`（`src/features/thread/lib/censorshipNotices.ts`）と
 * 同様に、Storageが使えない環境（プライベートモード等）でもクラッシュさせず、
 * 単に「毎回未読扱い」に縮退する。
 */

const STORAGE_KEY = "nijiurachan-announce-dismissed-banner-ids";
const MAX_STORED_IDS = 50;

type IdStorage = Pick<Storage, "getItem" | "setItem">;

export function isAnnouncementDismissed(
  id: number,
  storage: IdStorage | null = browserStorage(),
): boolean {
  return readDismissedIds(storage).includes(id);
}

export function dismissAnnouncement(
  id: number,
  storage: IdStorage | null = browserStorage(),
): void {
  if (!storage) return;
  const ids = readDismissedIds(storage);
  if (ids.includes(id)) return;
  try {
    storage.setItem(
      STORAGE_KEY,
      JSON.stringify([...ids, id].slice(-MAX_STORED_IDS)),
    );
  } catch {
    // Storage拒否時も同一ページ内の表示状態(Reactのstate)側で畳まれるため無視する
  }
}

function readDismissedIds(storage: IdStorage | null): number[] {
  if (!storage) return [];
  try {
    const parsed: unknown = JSON.parse(storage.getItem(STORAGE_KEY) ?? "[]");
    return Array.isArray(parsed)
      ? parsed.filter((id): id is number => typeof id === "number")
      : [];
  } catch {
    return [];
  }
}

function browserStorage(): IdStorage | null {
  try {
    return typeof localStorage === "undefined" ? null : localStorage;
  } catch {
    return null;
  }
}
